import { UserList } from '@/models/roster/user-list';
import { profileAPI } from '@/providers/apis/profile/profile';
import { FILE_UPLOAD_RESPONCE } from '@/utils/constants';
import moment from 'moment';

export class RosterSerializer {

    static get instance() {
        return this.INSTANCE;
    }
    private static INSTANCE = new RosterSerializer();

    public normalizeUserList(payload: any): UserList[] {
        const users = payload.users ? payload.users : [];
        return users;
    }

    public normalizeOrgsList(payload: any) {
        const orgs = payload.orgs ? payload.orgs : [];
        return orgs;
    }

    public async normalizeClassList(payload: any) {
        const classList = payload.classes ? payload.classes : [];
        for await (const iterator of classList) {
            iterator.teacherIds = [];
            iterator.type = 'class';
            iterator.teacherIds.push(iterator.creatorId);
            if (iterator.collaborator && iterator.collaborator.length > 0) {
                iterator.teacherIds = [...iterator.teacherIds, ...iterator.collaborator];
            }
            const userTeacher = iterator.teacherIds.join(',');
            iterator.teacherData = await profileAPI.fetchUserProfiles(userTeacher);
            iterator.showTeacherList = false;
        }
        const returnObj = {
            classes: classList,
            totalCounts: payload.totalCounts,
        };
        return returnObj;
    }

    public normalizeRosterList(payload: any) {
        const uploads = payload.uploads ? payload.uploads : [];
        const results: any = [];

        uploads.forEach((upload: any) => {
            const uploadStatistics = upload.uploadStatistics;
            const uploadItem = {
                fileName: upload.fileName || `OneRoster ${upload.oneRosterVersion}`,
                fileURL: upload.fileURL,
                status: upload.status,
                id: upload.id,
                tenantId: upload.tenantId,
                updatedAt: upload.updatedAt,
                createdAt: upload.createdAt,
                uploadStatistics,
                totalCounts: upload.totalCounts,
                totalSyncs: this.totalSyncs(upload.totalCounts),
                totalErrors: this.totalErrors(upload.totalCounts),
            };
            results.push(uploadItem);
        });

        const rosterList = {
            uploadList: results,
            totalCount: payload.totalCount ? payload.totalCount : 1,
        };
        return rosterList;
    }

    public normalizeRosterData(payload: any) {
        const upload = payload ? payload : {};
        const uploadStatistics = {
            success_records: upload.success_records,
            total_records: upload.total_records,
        };
        const uploadItem = {
            fileName: upload.fileName,
            fileURL: upload.fileURL,
            status: upload.status,
            id: upload.id,
            tenantId: upload.tenantId,
            updatedAt: upload.updatedAt,
            createdAt: upload.createdAt,
            uploadStatistics,
            totalCounts: upload.totalCounts,
            totalSyncs: this.totalSyncs(upload.totalCounts),
            totalErrors: this.totalErrors(upload.totalCounts),
        };
        return uploadItem;
    }

    public normalizeCountries(payload: any) {
        const countries = payload.countries ? payload.countries : [];
        return countries;
    }

    public normalizeCustomRosterData(payload: any) {
        const list = payload.list ? payload.list : [];
        if (list && list.length > 0) {
            for (const iterator of list) {
                iterator.id = iterator.oneroster_zip_upload_id;
                iterator.file_name = iterator.file_name || iterator.original_file_name;
                iterator.displayStatus = this.getDisplayStatus(iterator.status);
                iterator.error_message_list = [];
                if (iterator.status_message) {
                    if (iterator.status_message.message) {
                        const error = {
                            row: '-',
                            columnName: '-',
                            message: iterator.status_message.message,
                        };
                        iterator.error_message_list.push(error);
                    } else {
                        for (const errorRow in iterator.status_message) {
                            if (iterator.status_message.hasOwnProperty(errorRow)) {
                                for (const errorMsg in iterator.status_message[errorRow]) {
                                    if (iterator.status_message[errorRow].hasOwnProperty(errorMsg)) {
                                        const errorRowType = {
                                            row: errorRow,
                                            columnName: errorMsg,
                                            message: iterator.status_message[errorRow][errorMsg],
                                        };
                                        iterator.error_message_list.push(errorRowType);

                                    }
                                }
                            }
                        }
                    }

                }
            }
        }
        const customRosterList = {
            list,
            totalCounts: payload.totalCounts,
        };
        return customRosterList;
    }

    public normalizeStates(payload: any) {
        const states = payload.states ? payload.states : [];
        const overallStats = payload.overallStats ? payload.overallStats : {};
        overallStats.lastSyncDate = moment(overallStats.lastSyncDate).format('MM-DD-YYYY');
        return {
            states,
            overallStats,
        };
    }

    public normalizeAcl(payload: any) {
        const aclList = payload.ACL ? payload.ACL : [];
        const result: any = {};
        aclList.forEach((acl: any) => {
            if (!result[acl.type]) {
                result[acl.type] = [];
            }
            result[acl.type].push({
                id: acl.id,
                parentReferenceId: acl.parentReferenceId,
                groups: acl.groups,
            });
        });
        return result;
    }

    public normalizeRostersStats(payload: any) {
        return payload.overall_stats || {};
    }

    private totalSyncs(content: any) {
        const rosterTyes: any = Object.keys(content);
        let count = 0;
        rosterTyes.forEach((type: any) => {
            count += content[type].syncCount;
        });
        return count;
    }

    private totalErrors(content: any) {
        const rosterTyes: any = Object.keys(content);
        let count = 0;
        rosterTyes.forEach((type: any) => {
            count += content[type].errorCount;
        });
        return count;
    }

    private getDisplayStatus(status: any) {
        return status ? status === FILE_UPLOAD_RESPONCE.Error ? FILE_UPLOAD_RESPONCE.Error :
            status === FILE_UPLOAD_RESPONCE.SyncCompleted ? FILE_UPLOAD_RESPONCE.SyncCompleted :
            FILE_UPLOAD_RESPONCE.InProgress : FILE_UPLOAD_RESPONCE.InProgress;

    }

}

export const rosterSerializer = RosterSerializer.instance;
